<template>
  <div>
    <label class="tinylabel">
      (All Pipe Planner and Plastic Collections Data Related to Your Account
      Will Be Permanently Removed -- Including Pending Rebates)</label
    >

    <div id="verify_div">
      <div style="display: 'flex'">
        <label
          for="verify_email"
          v-html="
            `Please type <strong>${props.verificationValue}</strong> to confirm`
          "
        ></label>
        <br />
        <input
          id="verify_email"
          class="mt-1"
          name="email"
          type="email"
          v-model="validationEmail"
          size="20"
          autocomplete="off"
        />
      </div>

      <div class="delete-container">
        <input
          type="submit"
          :disabled="!finalDeleteEnabled"
          @click="finalDelete"
          value="Delete"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useApi } from "../plugins/api";
const $api = useApi();

const validationEmail = ref("");

const props = defineProps({
  verificationValue: { type: String, required: false },
});

const finalDeleteEnabled = computed(
  () => validationEmail.value === props?.verificationValue
);

async function finalDelete() {
  await $api.deleteUser();

  alert("Your Account Has Been Permanently Removed");

  window.location = "https://revolutioncompany.com";
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
a {
  cursor: pointer;
  text-decoration: underline;
}
#verify_div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#verify_email {
  width: 10em;
}

.tinylabel {
  font-size: x-small;
  font-style: italic;
}
.delete-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin:1rem 0
}
</style>
